import React, { useState, useEffect } from "react";
import "./style.css";
import { chracterPosition } from "../../../../utils/index";
import { colorCodesForAvatar } from "../../../../constants/index";
import { Avatar } from "@mui/material";
import { useDispatch } from "react-redux";
import { updateCCEmail } from "../../../../store/features/updateCCEmail";
import { getTicketMessagesById } from "../../../../store/features/getTicketMessagesById";
import { toast } from "react-toastify";

function RequestTicket({
  sideBarData,
  setChangeRequesterPopup,
  setShowAddRequesterPopup,
  onCCEmailsUpdate,
  /** `ticketv2`: smaller avatar, Figma-style “Add more people” row (circle + link) */
  variant = "sidebar",
}) {
  const dispatch = useDispatch();
  const [ccEmails, setCCEmails] = useState(sideBarData?.ccEmails || []);

  useEffect(() => {
    setCCEmails(sideBarData?.ccEmails || []);
  }, [sideBarData?.ccEmails]);

  const handleRemoveEmail = async (emailToRemove) => {
    const updatedEmails = ccEmails.filter((email) => email !== emailToRemove);
    setCCEmails(updatedEmails);
    
    if (onCCEmailsUpdate) {
      onCCEmailsUpdate(updatedEmails);
    }
    
    try {
      await dispatch(
        updateCCEmail({
          ticketId: sideBarData._id,
          ccEmails: updatedEmails,
        })
      ).unwrap();
      toast.success("Removed from loop");
      await dispatch(getTicketMessagesById(sideBarData._id)).unwrap();
    } catch (err) {
      toast.error("Failed to remove email");
      setCCEmails(ccEmails);

      if (onCCEmailsUpdate) {
        onCCEmailsUpdate(ccEmails);
      }
    }
  };

  return (
    <div className="SuperVisor-Main-Container">
      <div className="SuperVisor-Header-text">
        <p className="SuperVisorText">Requester</p>
        <p
          className="SuperVisorChange"
          onClick={() => setChangeRequesterPopup(true)}
        >
          Change
        </p>
      </div>
      <div className="SuperVisor-Logo-container">
        <Avatar
          sx={{
            width: variant === "ticketv2" ? 32 : 40,
            height: variant === "ticketv2" ? 32 : 40,
            mr: 1,
            fontSize: variant === "ticketv2" ? "13px" : "16px",
            fontWeight: "500",
            bgcolor:
              colorCodesForAvatar[
                chracterPosition(
                  sideBarData?.customerName?.substring(0, 1)?.toUpperCase()
                )
              ],
          }}
        >
          {(sideBarData?.customerName || "?").charAt(0).toUpperCase()}
        </Avatar>
        <div className="Super-Main-text">
          <p className="Super-Robert-text truncate">
            {sideBarData?.customerName
              ? sideBarData.customerName.charAt(0).toUpperCase() +
                sideBarData.customerName.slice(1)
              : ""}
          </p>
          <p className="Super-Kenzi-text truncate">
          {sideBarData?.customerEmail && typeof sideBarData?.customerEmail === "string"
                    ? sideBarData?.customerEmail.toLowerCase()
                    : sideBarData?.customerEmail}
          </p>
        </div>
      </div>
      {Array.isArray(ccEmails) && ccEmails.length > 0 && (
        <>
          <hr
            style={{
              margin: "16px 0",
              border: "none",
              borderTop: "1px solid #e0e0e0",
            }}
          />
          <div className="SuperVisor-Header-text">
            <p className="SuperVisorText" style={{ marginBottom: "15px" }}>
              People in the loop
            </p>
          </div>
          <div>
            {ccEmails.map((email) => (
              <div
                key={email}
                style={{
                  display: "flex",
                  alignItems: "center",
                  minWidth: 0,
                  gap: 8,
                  paddingBottom: "16px",
                }}
              >
                <Avatar
                  sx={{
                    width: 40,
                    height: 40,
                    mr: 1,
                    fontSize: "15px",
                    fontWeight: "500",
                    bgcolor:
                      colorCodesForAvatar[
                        chracterPosition(email?.substring(0, 1)?.toUpperCase())
                      ],
                  }}
                >
                  {email.charAt(0).toUpperCase()}
                </Avatar>
                <span
                  className="Super-Kenzi-text"
                  style={{
                    flex: 1,
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    marginRight: 8,
                  }}
                  title={
                    email && typeof email === "string"
                      ? email.toLowerCase()
                      : email
                  }
                >
                  {email && typeof email === "string"
                    ? email.toLowerCase()
                    : email}
                </span>
                <span
                  className="CC-Remove"
                  onClick={() => handleRemoveEmail(email)}
                  style={{ flexShrink: 0 }}
                >
                  Remove
                </span>
              </div>
            ))}
          </div>
        </>
      )}
      {variant === "ticketv2" ? (
        <div
          role="button"
          tabIndex={0}
          onClick={() => setShowAddRequesterPopup(true)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              setShowAddRequesterPopup(true);
            }
          }}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginTop: ccEmails.length > 0 ? 8 : 14,
            cursor: "pointer",
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,
              borderRadius: 16,
              border: "1px solid #E5E9EC",
              background: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
              boxShadow: "0px 1px 2px 0px rgba(6, 21, 34, 0.05)",
            }}
          >
            <span style={{ color: "#148DFD", fontSize: 17, lineHeight: 1, fontWeight: 400 }}>+</span>
          </div>
          <span
            style={{
              color: "#148DFD",
              fontFamily: "Inter, sans-serif",
              fontSize: 14,
              fontWeight: 400,
              lineHeight: "18px",
              textDecoration: `${variant === "ticketv2" ? "none" : "underline"}`,
              textUnderlineOffset: "2px",
            }}
          >
            Add more people
          </span>
        </div>
      ) : (
        <p
          className="ticketChagnetext"
          style={{
            marginLeft: "48px",
            marginTop: ccEmails.length > 0 ? "0px" : "17px",
          }}
          onClick={() => setShowAddRequesterPopup(true)}
        >
          + Add more people
        </p>
      )}
    </div>
  );
}

export default RequestTicket;
